import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { arrayHas } from "../../../utils/arrayHas.js";
import { createAction } from "../../../r-html/dist/store/index.js";
import { addAndSort } from "../../../utils/collection/sequence.js";
import { createIndex } from "../../../utils/collection/index.entity.js";
import { ActionType } from "./actions.js";
import { createIndexColumn } from "../../../utils/collection/indexColumn.entity.js";
//#region src/engine/modules/index-column/atom.actions.ts
var addIndexColumnAction = createAction(ActionType.addIndexColumn);
var addIndexColumn = ({ collections, lww }, { payload: { id, indexId, tableId, columnId }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const indexCollection = query(collections).collection("indexEntities");
	const index = indexCollection.getOrCreate(indexId, (id) => createIndex({
		id,
		tableId
	}));
	query(collections).collection("indexColumnEntities").addOne(createIndexColumn({
		id,
		indexId,
		columnId
	})).addOperator(lww, safeVersion, id, () => {
		if (!arrayHas(index.indexColumnIds)(id)) indexCollection.updateOne(indexId, (index) => {
			addAndSort(index.indexColumnIds, index.seqIndexColumnIds, id);
		});
	});
};
var removeIndexColumnAction = createAction(ActionType.removeIndexColumn);
var removeIndexColumn = ({ collections, lww }, { payload: { id, indexId, tableId }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const indexCollection = query(collections).collection("indexEntities");
	const index = indexCollection.getOrCreate(indexId, (id) => createIndex({
		id,
		tableId
	}));
	query(collections).collection("indexColumnEntities").removeOperator(lww, safeVersion, id, () => {
		const i = index.indexColumnIds.indexOf(id);
		if (i !== -1) indexCollection.updateOne(indexId, (index) => {
			index.indexColumnIds.splice(i, 1);
		});
	});
};
var moveIndexColumnAction = createAction(ActionType.moveIndexColumn);
var moveIndexColumn = ({ collections }, { payload: { id, indexId, tableId, targetId } }) => {
	if (id === targetId) return;
	const indexCollection = query(collections).collection("indexEntities");
	const index = indexCollection.getOrCreate(indexId, (id) => createIndex({
		id,
		tableId
	}));
	const i = index.indexColumnIds.indexOf(id);
	if (i === -1) return;
	const targetIndex = index.indexColumnIds.indexOf(targetId);
	if (targetIndex === -1) return;
	indexCollection.updateOne(indexId, (index) => {
		index.indexColumnIds.splice(i, 1);
		index.indexColumnIds.splice(targetIndex, 0, id);
		const seqIndex = index.seqIndexColumnIds.indexOf(id);
		const seqTargetIndex = index.seqIndexColumnIds.indexOf(targetId);
		if (seqIndex !== -1 && seqTargetIndex !== -1) {
			index.seqIndexColumnIds.splice(seqIndex, 1);
			index.seqIndexColumnIds.splice(seqTargetIndex, 0, id);
		}
	});
};
var changeIndexColumnOrderTypeAction = createAction(ActionType.changeIndexColumnOrderType);
var changeIndexColumnOrderType = ({ collections, lww }, { payload: { id, indexId, columnId, value }, version }, { clock }) => {
	const safeVersion = version ?? clock.getVersion();
	const collection = query(collections).collection("indexColumnEntities");
	collection.getOrCreate(id, (id) => createIndexColumn({
		id,
		indexId,
		columnId
	}));
	collection.replaceOperator(lww, safeVersion, id, "orderType", () => {
		collection.updateOne(id, (indexColumn) => {
			indexColumn.orderType = value;
		});
	});
};
var indexColumnReducers = {
	[ActionType.addIndexColumn]: addIndexColumn,
	[ActionType.removeIndexColumn]: removeIndexColumn,
	[ActionType.moveIndexColumn]: moveIndexColumn,
	[ActionType.changeIndexColumnOrderType]: changeIndexColumnOrderType
};
var actions = {
	addIndexColumnAction,
	removeIndexColumnAction,
	moveIndexColumnAction,
	changeIndexColumnOrderTypeAction
};
//#endregion
export { actions, addIndexColumnAction, changeIndexColumnOrderTypeAction, indexColumnReducers, moveIndexColumnAction, removeIndexColumnAction };
